import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsCards = ({ dealerships }) => {
  const activeCount = dealerships?.filter(d => d?.status === 'active')?.length || 0;
  const inactiveCount = dealerships?.filter(d => d?.status === 'inactive')?.length || 0;
  const totalCount = dealerships?.length || 0;

  const stats = [
    {
      label: 'Gesamt',
      value: totalCount,
      icon: 'Building2',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
    },
    {
      label: 'Aktiv',
      value: activeCount,
      icon: 'CheckCircle',
      color: 'text-green-600',
      bgColor: 'bg-green-50',
    },
    {
      label: 'Inaktiv',
      value: inactiveCount,
      icon: 'XCircle',
      color: 'text-gray-600',
      bgColor: 'bg-gray-50',
    },
  ];

  return (
    <div className="mobile-grid">
      {stats?.map((stat, index) => (
        <div 
          key={index} 
          className="mobile-card touch-feedback-subtle"
        >
          <div className="flex items-center justify-between">
            <div className="flex-1">
              <p className="mobile-caption text-muted-foreground mb-1">
                {stat?.label}
              </p>
              <p className="mobile-heading text-foreground">
                {stat?.value}
              </p>
            </div>
            <div className={`touch-target flex items-center justify-center rounded-xl ${stat?.bgColor}`}>
              <Icon 
                name={stat?.icon} 
                size={24} 
                className={stat?.color}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsCards;